import { BrowserCacheLocation, IPublicClientApplication, PublicClientApplication, InteractionType } from '@azure/msal-browser';
import { MsalGuardConfiguration, MsalInterceptorConfiguration } from '@azure/msal-angular';
import { environment } from '../../environments/environment';

const isIE = window.navigator.userAgent.indexOf('MSIE') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;

export function MSALInstanceFactory(): IPublicClientApplication {
    return new PublicClientApplication({
        auth: {
            clientId: environment.msalModuleConfig.clientId,
            authority: environment.msalModuleConfig.authority,
            redirectUri: environment.msalModuleConfig.redirectUri || window.location.origin,
            postLogoutRedirectUri: environment.msalModuleConfig.redirectUri || window.location.origin,
            navigateToLoginRequestUrl: true
        },
        system: {
            allowRedirectInIframe: true,
            allowNativeBroker: false
        },
        cache: {
            cacheLocation: BrowserCacheLocation.LocalStorage,
            storeAuthStateInCookie: isIE
        }
    });
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
    const scopes = environment.msalModuleConfig.scopes ? [environment.msalModuleConfig.scopes] : [];
    return {
        interactionType: InteractionType.Redirect,
        authRequest: {
            scopes
        }
    };
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
    const protectedResourceMap = new Map<string, Array<string>>();
    // No interceptor registrations: MSAL tokens are passed explicitly where needed.
    return {
        interactionType: InteractionType.Redirect,
        protectedResourceMap
    };
}
